import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tLinc/Store/CustomHandlerCreator/CustomHandlerCreator";

interface BillingShippingParameter {
    billTo: string;
    shipTo: string;
}

type HandlerType = CustomHandler<BillingShippingParameter>;

export const UpdateBillToShipTo: HandlerType = props => {
    props.dispatch({
        type: "Custom/ShipTos/ChangeBillTosShipTosContext",
        result: props.parameter,
    });
};

export const chain = [UpdateBillToShipTo];

const updateBillToShipTo = createHandlerChainRunner(chain, "UpdateBillToShipTo");

export default updateBillToShipTo;
